<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      Egadnos respecte les prérogatives du RGPD, de la manière suivante : <br>
      <ul>
        <li>Vos données ne sont pas envoyées à des tiers</li>
        <li>Vous pouvez choisir de les enregistrer sur le POD de l'auteur du sondage ou sur votre propre POD</li>
        <li>Vous pouvez à tout moment contacter le propriétaire du POD où sont stockées vos données pour lui demander de les consulter, les rectifier ou de les supprimer</li>
      </ul>
      pour utiliser Egadnos,
      et configurer votre formulaire <a href="/about"> About/config</a>
      ou
      <a href='http://scenaristeur.github.io/egadnos?service={"name": "Egadnos", "logo": "https://scenaristeur.github.io/cdr/img/header-bg.jpg", "pod": "https://egadnos.solidweb.org", "url": "http://scenaristeur.github.io/egadnos", "confidentialite": "public"}' target="_blank" rel="noopener">Donnez votre avis sur Egadnos</a>.
    </p>

    <!-- <h3>Installed CLI Plugins</h3>
    <ul>
    <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-babel" target="_blank" rel="noopener">babel</a></li>
    <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-pwa" target="_blank" rel="noopener">pwa</a></li>
    <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-router" target="_blank" rel="noopener">router</a></li>
    <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-vuex" target="_blank" rel="noopener">vuex</a></li>
    <li><a href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint" target="_blank" rel="noopener">eslint</a></li>
  </ul>
  <h3>Essential Links</h3>
  <ul>
  <li><a href="https://vuejs.org" target="_blank" rel="noopener">Core Docs</a></li>
  <li><a href="https://forum.vuejs.org" target="_blank" rel="noopener">Forum</a></li>
  <li><a href="https://chat.vuejs.org" target="_blank" rel="noopener">Community Chat</a></li>
  <li><a href="https://twitter.com/vuejs" target="_blank" rel="noopener">Twitter</a></li>
  <li><a href="https://news.vuejs.org" target="_blank" rel="noopener">News</a></li>
</ul>
<h3>Ecosystem</h3>
<ul>
<li><a href="https://router.vuejs.org" target="_blank" rel="noopener">vue-router</a></li>
<li><a href="https://vuex.vuejs.org" target="_blank" rel="noopener">vuex</a></li>
<li><a href="https://github.com/vuejs/vue-devtools#vue-devtools" target="_blank" rel="noopener">vue-devtools</a></li>
<li><a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener">vue-loader</a></li>
<li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
</ul> -->
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  /*  list-style-type: none;*/
  padding: 0;
}
li {
  /*  display: inline-block;*/
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
